module.exports = __webpack_public_path__ + "assets/711ab07564c17336444360e8a1def5b5.png";